
<div class="admin-page">
<div class="admin-header">
  <h2>Admin Dashboard</h2>

  <button mat-raised-button color="warn" (click)="logout()">
    <mat-icon>logout</mat-icon>
    Logout
  </button>
</div>

  <mat-tab-group mat-align-tabs="center">
<mat-tab label="Appointments">
<!-- FILTER & SORT BAR -->
<div class="appointment-toolbar">

  <!-- STATUS FILTER -->
  <mat-form-field appearance="outline" class="toolbar-field">
    <mat-label>Status</mat-label>
    <mat-select [(ngModel)]="filterStatus" (selectionChange)="applyFilters()">
      <mat-option value="">All</mat-option>
      <mat-option value="pending">Pending</mat-option>
      <mat-option value="approved">Approved</mat-option>
      <mat-option value="completed">Completed</mat-option>
      <mat-option value="cancelled">Cancelled</mat-option>
      <mat-option value="denied">Denied</mat-option>
    </mat-select>
  </mat-form-field>

  <!-- SORT FIELD -->
  <mat-form-field appearance="outline" class="toolbar-field">
    <mat-label>Sort By</mat-label>
    <mat-select [(ngModel)]="sortField" (selectionChange)="applyFilters()">
      <mat-option value="preferredDate">Appointment Date</mat-option>
      <mat-option value="created">Created Date</mat-option>
    </mat-select>
  </mat-form-field>

  <!-- SORT ORDER -->
  <button
    mat-stroked-button
    color="primary"
    (click)="toggleSortOrder()"
  >
    {{ sortOrder === 'asc' ? 'Ascending ↑' : 'Descending ↓' }}
  </button>

</div>

  <div class="appointments-grid">

    <mat-card
      class="appointment-card"
      [ngClass]="a.status"
      *ngFor="let a of filteredAppointments"
    >

      <!-- Appointment Date -->
      <div class="appointment-date">
        {{ a.preferredDate?.toDate() | date:'dd MMM yyyy, hh:mm a' }}
      </div>
      <div class="status-badge" [ngClass]="a.status">
        {{ a.status | uppercase }}
      </div>
      <!-- Basic Info -->
      <div class="appointment-basic">
        <h3>{{ a.patient_name }}</h3>
        <p class="phone">
          <mat-icon>phone</mat-icon> {{ a.phone }}
        </p>
      </div>

      <!-- Expandable Section (ONLY THIS CARD) -->
      <div class="appointment-extra">
        <p><strong>Email:</strong> {{ a.email }}</p>
        <p><strong>Service:</strong> {{ a.service_type }}</p>
        <p><strong>Message:</strong> {{ a.message }}</p>

        <p *ngIf="a.approvedAt">
          <strong>Approved:</strong> {{ a.approvedAt?.toDate() | date:'dd MMM yyyy, hh:mm a' }}
        </p>
        <p *ngIf="a.completedAt">
          <strong>Completed:</strong> {{ a.completedAt?.toDate() | date:'dd MMM yyyy, hh:mm a' }}
        </p>
        <p *ngIf="a.cancelledAt">
          <strong>Cancelled:</strong> {{ a.cancelledAt?.toDate() | date:'dd MMM yyyy, hh:mm a' }}
        </p>
        <p *ngIf="a.deniedAt">
          <strong>Denied:</strong> {{ a.deniedAt?.toDate() | date:'dd MMM yyyy, hh:mm a' }}
        </p>

        <p class="status">
          <strong>Status:</strong> {{ a.status | uppercase }}
        </p>
      <!-- NOTES LIST -->
      <div class="notes-section" *ngIf="a.notes?.length">
        <p class="notes-title">Notes</p>
        <ul>
          <li *ngFor="let n of a.notes">
            {{ n.text }}
          </li>
        </ul>
      </div>

      <!-- ADD NOTE (VISIBLE ON HOVER) -->
      <mat-form-field appearance="outline" class="notes-input">
        <mat-label>Add note</mat-label>
        <textarea
          matInput
          rows="2"
          [(ngModel)]="a._noteText"
          (keydown.enter)="submitNote(a)"
        ></textarea>
      </mat-form-field>

      <!-- SUBMIT BUTTON (ONLY IF TEXT EXISTS) -->
      <button
        mat-stroked-button
        color="primary"
        class="submit-note-btn"
        *ngIf="a._noteText?.trim()"
        (click)="submitNote(a)"
      >
        Submit Notes
      </button>
      </div>


      <!-- ACTIONS -->
      <div class="appointment-actions">

        <!-- Pending -->
        <ng-container *ngIf="a.status === 'pending'">
          <button mat-stroked-button color="primary" (click)="approveAppointment(a)">
            Approve
          </button>
          <button mat-stroked-button color="warn" (click)="denyAppointment(a)">
            Deny
          </button>
        </ng-container>

        <!-- Approved -->
        <ng-container *ngIf="a.status === 'approved'">
          <button mat-stroked-button color="primary" (click)="completeAppointment(a)">
            Completed
          </button>
          <button mat-stroked-button color="warn" (click)="cancelAppointment(a)">
            Cancelled
          </button>
        </ng-container>

      </div>

    </mat-card>

  </div>
</mat-tab>

    <mat-tab label="Visitor Logs">
      <div class="tab-content">

        <!-- FILTER BAR -->
        <div class="appointment-toolbar">
          <mat-form-field appearance="outline" class="toolbar-field">
            <mat-label>Period</mat-label>
            <mat-select [(ngModel)]="visitorRange" (selectionChange)="refreshToday()">
              <mat-option value="today">Today</mat-option>
              <mat-option value="7d">Last 7 days</mat-option>
              <mat-option value="30d">Last 30 days</mat-option>
              <mat-option value="custom">Custom date range</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="toolbar-field visitor-range-field" *ngIf="visitorRange === 'custom'">
            <mat-label>Date range</mat-label>
            <mat-date-range-input [rangePicker]="visitorRangePicker" [max]="today">
              <input matStartDate [(ngModel)]="customFrom" placeholder="Start date">
              <input matEndDate [(ngModel)]="customTo" placeholder="End date">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="visitorRangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #visitorRangePicker (opened)="refreshToday()"></mat-date-range-picker>
            <mat-hint>Pick a start and end date</mat-hint>
          </mat-form-field>

          <button mat-raised-button color="primary" (click)="loadVisitorLogs()" [disabled]="!canLoadVisitorLogs()">
            <mat-icon>download</mat-icon>
            {{ visitorLogsLoading ? 'Loading…' : 'Load' }}
          </button>

          <mat-slide-toggle
            class="visitor-optout"
            [checked]="excludeThisBrowser"
            (change)="toggleExcludeThisBrowser($event.checked)"
          >
            Don't track my visits on this browser
          </mat-slide-toggle>
        </div>

        <p class="visitor-error" *ngIf="visitorLogsError">{{ visitorLogsError }}</p>
        <p class="visitor-note" *ngIf="!visitorLogsLoaded && !visitorLogsLoading">
          Choose a period and press <b>Load</b>. Nothing is read from Firestore until you do
          (up to {{ visitorPageSize }} visits per press).
        </p>
        <p class="visitor-note" *ngIf="visitorLogsLoaded">
          Showing {{ visitorStats.visits }} visit(s) for <b>{{ visitorLoadedLabel }}</b><ng-container *ngIf="visitorHasMore">
          — more visits exist in this period; the totals below cover the loaded visits only</ng-container>.
        </p>

        <!-- SUMMARY -->
        <div class="visitor-stats" *ngIf="visitorLogsLoaded">
          <div class="visitor-stat">
            <span class="visitor-stat-value">{{ visitorStats.visits }}</span>
            <span class="visitor-stat-label">Visits</span>
          </div>
          <div class="visitor-stat">
            <span class="visitor-stat-value">{{ visitorStats.uniqueVisitors }}</span>
            <span class="visitor-stat-label">Unique visitors</span>
          </div>
          <div class="visitor-stat">
            <span class="visitor-stat-value">{{ formatDuration(visitorStats.avgSeconds) }}</span>
            <span class="visitor-stat-label">Avg. time on site</span>
          </div>
          <div class="visitor-stat">
            <span class="visitor-stat-value">{{ visitorStats.booked }}</span>
            <span class="visitor-stat-label">Booked an appointment</span>
          </div>
          <div class="visitor-stat">
            <span class="visitor-stat-value">{{ visitorStats.topSection }}</span>
            <span class="visitor-stat-label">Most viewed section</span>
          </div>
        </div>

        <!-- TIME PER SECTION -->
        <div class="section-breakdown" *ngIf="visitorStats.visits">
          <h3>Time spent per section</h3>
          <div class="section-row" *ngFor="let s of sectionStats">
            <span class="section-name">{{ s.label }}</span>
            <div class="section-bar">
              <div class="section-bar-fill" [style.width.%]="s.barPercent"></div>
            </div>
            <span class="section-time">{{ formatDuration(s.seconds) }}</span>
            <span class="section-reach">{{ s.reachPercent }}% of visits</span>
          </div>
        </div>

        <!-- EVERY VISIT -->
        <div class="table-scroll">
          <table
            mat-table
            [dataSource]="visitorLogDS"
            matSort
            #visitorLogSort="matSort"
            matSortActive="startedAt"
            matSortDirection="desc"
            class="mat-elevation-z1"
          >

            <ng-container matColumnDef="startedAt">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Arrived</th>
              <td mat-cell *matCellDef="let v">{{ v.startedAt | date:'dd MMM yyyy, hh:mm a' }}</td>
            </ng-container>

            <ng-container matColumnDef="durationSeconds">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Time on site</th>
              <td mat-cell *matCellDef="let v">{{ formatDuration(v.durationSeconds) }}</td>
            </ng-container>

            <ng-container matColumnDef="sections">
              <th mat-header-cell *matHeaderCellDef>Sections viewed (in order)</th>
              <td mat-cell *matCellDef="let v">
                <div class="visit-sections">
                  <span class="visit-section" *ngFor="let s of v.sections">
                    {{ s.label }} · {{ formatDuration(s.seconds) }}
                  </span>
                  <span class="muted" *ngIf="!v.sections.length">—</span>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="exitSection">
              <th mat-header-cell *matHeaderCellDef>Left from</th>
              <td mat-cell *matCellDef="let v">{{ v.exitSection || '—' }}</td>
            </ng-container>

            <ng-container matColumnDef="device">
              <th mat-header-cell *matHeaderCellDef>Device</th>
              <td mat-cell *matCellDef="let v">
                <span class="visit-device">
                  <mat-icon>{{ deviceIcon(v.device) }}</mat-icon>
                  {{ v.browser || 'Unknown' }}<ng-container *ngIf="v.os"> · {{ v.os }}</ng-container>
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="source">
              <th mat-header-cell *matHeaderCellDef>Came from</th>
              <td mat-cell *matCellDef="let v">{{ v.source }}</td>
            </ng-container>

            <ng-container matColumnDef="visitor">
              <th mat-header-cell *matHeaderCellDef>Visitor</th>
              <td mat-cell *matCellDef="let v">
                {{ v.isReturning ? 'Returning · visit #' + v.visitNumber : 'New' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="booked">
              <th mat-header-cell *matHeaderCellDef>Booked</th>
              <td mat-cell *matCellDef="let v">
                <span class="booked-yes" *ngIf="v.bookedAppointment">✓ Yes</span>
                <span class="muted" *ngIf="!v.bookedAppointment">—</span>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="visitorLogColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: visitorLogColumns"></tr>

            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell visitor-empty" [attr.colspan]="visitorLogColumns.length">
                {{ visitorLogsLoading ? 'Loading visits…' : visitorLogsLoaded ? 'No visits in this period.' : 'Press Load to see visits.' }}
              </td>
            </tr>
          </table>
        </div>

        <mat-paginator #visitorLogPaginator [pageSize]="10" [pageSizeOptions]="[10,25,50,100]">
        </mat-paginator>

        <div class="visitor-load-more" *ngIf="visitorHasMore">
          <button mat-stroked-button color="primary" (click)="loadMoreVisitorLogs()" [disabled]="visitorLogsLoading">
            <mat-icon>expand_more</mat-icon>
            {{ visitorLogsLoading ? 'Loading…' : 'Load ' + visitorPageSize + ' more' }}
          </button>
        </div>

      </div>
    </mat-tab>

    <mat-tab label="Services">
      <div class="tab-content">
        <form [formGroup]="serviceForm" class="form-card">
          <mat-form-field appearance="outline">
            <mat-label>Service Name</mat-label>
            <input matInput formControlName="name">
          </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Icon</mat-label>
              <mat-select formControlName="icon">
                <mat-select-trigger>
                  <span class="icon-option" *ngIf="serviceForm.value.icon">
                    <span
                      class="icon-svg"
                      [innerHTML]="getIconSvg(serviceForm.value.icon)">
                    </span>
                    <span class="icon-label">
                      {{ serviceForm.value.icon }}
                    </span>
                  </span>

                  <span *ngIf="!serviceForm.value.icon">
                    Select icon
                  </span>
                </mat-select-trigger>
                <mat-option *ngFor="let i of iconList" [value]="i">
                  <span class="icon-option">
                    <span class="icon-svg" [innerHTML]="getIconSvg(i)"></span>
                    <span class="icon-label">{{ i }}</span>
                  </span>
                </mat-option>

              </mat-select>
            </mat-form-field>

          <!-- <mat-form-field appearance="outline">
            <mat-label>Icon</mat-label>
            <mat-select formControlName="icon">
              <mat-option *ngFor="let i of iconList" [value]="i">
                {{ i }}
              </mat-option>
            </mat-select>
          </mat-form-field> -->

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Description</mat-label>
            <textarea matInput rows="3" formControlName="description"></textarea>
          </mat-form-field>

          <div class="slide-toggle-wrapper">
            <mat-slide-toggle formControlName="featured">Featured</mat-slide-toggle>
          </div>

          <div class="action-row">
            <button mat-raised-button color="primary" (click)="saveService()">
              {{ editingServiceId ? 'Update Service' : 'Add Service' }}
            </button>
            <button mat-stroked-button *ngIf="editingServiceId" (click)="resetServiceForm()">
              Clear
            </button>
          </div>
        </form>

        <table mat-table [dataSource]="serviceDS" matSort #serviceSort="matSort" class="mat-elevation-z1">

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
            <td mat-cell *matCellDef="let r">{{ r.name }}</td>
          </ng-container>

          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let r">{{ r.description }}</td>
          </ng-container>

          <ng-container matColumnDef="icon">
            <th mat-header-cell *matHeaderCellDef>Icon</th>
            <td mat-cell *matCellDef="let r">
              <span class="icon-option">
                <span class="icon-svg" [innerHTML]="getIconSvg(r.icon.key)"></span>
                <span class="icon-label">{{ r.icon.key }}</span>
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="featured">
            <th mat-header-cell *matHeaderCellDef>Featured</th>
            <td mat-cell *matCellDef="let r">{{ r.featured ? 'Yes' : 'No' }}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let r">
              <button mat-icon-button color="primary" (click)="editService(r)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="deleteService(r.id)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="serviceColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: serviceColumns"></tr>
        </table>

        <mat-paginator #servicePaginator [pageSize]="5" [pageSizeOptions]="[5,10,20]">
        </mat-paginator>

      </div>
    </mat-tab>
    <mat-tab label="Doctors">
      <div class="tab-content">

        <form [formGroup]="doctorForm" class="form-card">
          <mat-form-field appearance="outline">
            <mat-label>Doctor Name</mat-label>
            <input matInput formControlName="doctorname">
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Qualification</mat-label>
            <input matInput formControlName="qualification">
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Specialization</mat-label>
            <input matInput formControlName="specialization">
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Experience (Years)</mat-label>
            <input matInput type="number" formControlName="experience">
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Image URL</mat-label>
            <input matInput formControlName="imageurl">
          </mat-form-field>

          <div class="action-row">
            <button mat-raised-button color="primary" (click)="saveDoctor()">
              {{ editingDoctorId ? 'Update Doctor' : 'Add Doctor' }}
            </button>
            <button mat-stroked-button *ngIf="editingDoctorId" (click)="resetDoctorForm()">
              Clear
            </button>
          </div>
        </form>

        <table mat-table [dataSource]="doctorDS" matSort #doctorSort="matSort" class="mat-elevation-z1">

          <ng-container matColumnDef="doctorname">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let d">{{ d.doctorname }}</td>
          </ng-container>

          <ng-container matColumnDef="qualification">
            <th mat-header-cell *matHeaderCellDef>Qualification</th>
            <td mat-cell *matCellDef="let d">{{ d.qualification }}</td>
          </ng-container>

          <ng-container matColumnDef="specialization">
            <th mat-header-cell *matHeaderCellDef>Specialization</th>
            <td mat-cell *matCellDef="let d">{{ d.specialization }}</td>
          </ng-container>

          <ng-container matColumnDef="experience">
            <th mat-header-cell *matHeaderCellDef>Experience</th>
            <td mat-cell *matCellDef="let d">{{ d.experience }} yrs</td>
          </ng-container>

          <ng-container matColumnDef="image">
            <th mat-header-cell *matHeaderCellDef>Image</th>
            <td mat-cell *matCellDef="let d">
              <img [src]="d.imageurl" alt="{{ d.doctorname }}" class="doctor-avatar">
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let d">
              <button mat-icon-button color="primary" (click)="editDoctor(d)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="deleteDoctor(d.id)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="doctorColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: doctorColumns"></tr>
        </table>

        <mat-paginator #doctorPaginator [pageSize]="5" [pageSizeOptions]="[5,10,20]">
        </mat-paginator>

      </div>
    </mat-tab>
    <mat-tab label="Testimonials">
      <div class="tab-content">

        <form [formGroup]="testimonialForm" class="form-card">
          <mat-form-field appearance="outline">
            <mat-label>Patient Name</mat-label>
            <input matInput formControlName="patientName">
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Testimonial</mat-label>
            <textarea matInput rows="3" formControlName="testimonial"></textarea>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Rating (1 to 5)</mat-label>
            <input
              matInput
              type="number"
              formControlName="rating"
              min="1"
              max="5">
            <mat-hint>Only values between 1 and 5 allowed</mat-hint>
          </mat-form-field>

          <div class="action-row">
            <button mat-raised-button color="primary" (click)="saveTestimonial()">
              {{ editingTestimonialId ? 'Update Testimonial' : 'Add Testimonial' }}
            </button>
            <button mat-stroked-button *ngIf="editingTestimonialId" (click)="resetTestimonialForm()">
              Clear
            </button>
          </div>
        </form>

        <table mat-table [dataSource]="testimonialDS" matSort #testimonialSort="matSort" class="mat-elevation-z1">

          <ng-container matColumnDef="patientName">
            <th mat-header-cell *matHeaderCellDef>Patient</th>
            <td mat-cell *matCellDef="let t">{{ t.patientName }}</td>
          </ng-container>

          <ng-container matColumnDef="testimonial">
            <th mat-header-cell *matHeaderCellDef>Testimonial</th>
            <td mat-cell *matCellDef="let t">{{ t.testimonial }}</td>
          </ng-container>

          <ng-container matColumnDef="rating">
            <th mat-header-cell *matHeaderCellDef>Rating</th>
            <td mat-cell *matCellDef="let t">
              {{ t.rating }} ⭐
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let t">
              <button mat-icon-button color="primary" (click)="editTestimonial(t)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="deleteTestimonial(t.id)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="testimonialColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: testimonialColumns"></tr>
        </table>

        <mat-paginator #testimonialPaginator [pageSize]="5" [pageSizeOptions]="[5,10,20]">
        </mat-paginator>

      </div>
    </mat-tab>
    <mat-tab label="Service Types">
      <div class="tab-content">
        <div class="form-card">

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Add Service Type</mat-label>
            <input
              matInput
              [(ngModel)]="serviceTypeInput"
              (keyup.enter)="addServiceType()"
              placeholder="Eg: Sports Injury Rehabilitation">
          </mat-form-field>

          <button
            mat-raised-button
            color="primary"
            (click)="addServiceType()">
            Add
          </button>
        </div>
        <mat-chip-listbox class="service-chip-list">
          <mat-chip
            *ngFor="let type of serviceTypes"
            removable
            (removed)="removeServiceType(type)">

            {{ type }}

            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>

          </mat-chip>
        </mat-chip-listbox>

      </div>
    </mat-tab>
    <mat-tab label="FAQ">
      <div class="tab-content">

        <form [formGroup]="faqForm" class="form-card">
          <mat-form-field appearance="outline">
            <mat-label>Question</mat-label>
            <input matInput formControlName="question">
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Answer</mat-label>
            <textarea matInput rows="3" formControlName="answer"></textarea>
          </mat-form-field>

          <div class="slide-toggle-wrapper">
            <mat-slide-toggle formControlName="isOpen">isOpen</mat-slide-toggle>
          </div>

          <div class="action-row">
            <button mat-raised-button color="primary" (click)="saveFaq()">
              {{ editingFaqId ? 'Update Faq' : 'Add Faq' }}
            </button>
            <button mat-stroked-button *ngIf="editingFaqId" (click)="resetFaqForm()">
              Clear
            </button>
          </div>
        </form>

        <table mat-table [dataSource]="faqDS" matSort #faqSort="matSort" class="mat-elevation-z1">

          <ng-container matColumnDef="question">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Question</th>
            <td mat-cell *matCellDef="let r">{{ r.question }}</td>
          </ng-container>

          <ng-container matColumnDef="answer">
            <th mat-header-cell *matHeaderCellDef>Answer</th>
            <td mat-cell *matCellDef="let r">{{ r.answer }}</td>
          </ng-container>

          <ng-container matColumnDef="isopen">
            <th mat-header-cell *matHeaderCellDef>Open</th>
            <td mat-cell *matCellDef="let r">{{ r.isOpen ? 'Yes' : 'No' }}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let r">
              <button mat-icon-button color="primary" (click)="editFaq(r)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="deleteFaq(r.id)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="faqColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: faqColumns"></tr>
        </table>

        <mat-paginator #faqPaginator [pageSize]="5" [pageSizeOptions]="[5,10,20]">
        </mat-paginator>

      </div>
    </mat-tab>
    <mat-tab label="Settings">
      <div class="tab-content">
      <h1 style="padding: 20px;">Time configuration</h1>
        <div class="form-card">
<form [formGroup]="timeConfigForm">
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Start time</mat-label>
    <input matInput formControlName="starttime" placeholder="8:00AM">

    <mat-hint>Format: 8:00AM, 10:30PM (12 hour only)</mat-hint>

    <mat-error *ngIf="timeConfigForm.get('starttime')?.hasError('required')">
      Start time is required
    </mat-error>

    <mat-error *ngIf="timeConfigForm.get('starttime')?.hasError('pattern')">
      Only 12 hour format allowed (example: 8:00AM)
    </mat-error>
  </mat-form-field>

  <!-- End time -->
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>End time</mat-label>
    <input matInput formControlName="endtime" placeholder="9:00PM">

    <mat-hint>Format: 8:00AM, 10:30PM (12 hour only)</mat-hint>

    <mat-error *ngIf="timeConfigForm.get('endtime')?.hasError('required')">
      End time is required
    </mat-error>

    <mat-error *ngIf="timeConfigForm.get('endtime')?.hasError('pattern')">
      Only 12 hour format allowed (example: 9:00PM)
    </mat-error>

    <mat-error *ngIf="isEndTimeInvalid()">
      End time must be after start time
    </mat-error>
  </mat-form-field>

  <!-- Weekly holidays -->
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Weekly holidays</mat-label>
    <mat-select multiple formControlName="holiday">

      <mat-option *ngFor="let d of weekDays" [value]="d">
        {{ d | titlecase }}
      </mat-option>

    </mat-select>

    <mat-error *ngIf="timeConfigForm.get('holiday')?.hasError('required')">
      Select at least one holiday
    </mat-error>
  </mat-form-field>

  <!-- Visit duration -->
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Visit duration (minutes)</mat-label>
    <input
      matInput
      formControlName="visitdurationminutes"
      placeholder="45"
      inputmode="numeric"
    >

    <mat-hint>Only numbers between 1 and 120</mat-hint>

    <mat-error *ngIf="timeConfigForm.get('visitdurationminutes')?.hasError('required')">
      Visit duration is required
    </mat-error>

    <mat-error *ngIf="timeConfigForm.get('visitdurationminutes')?.hasError('pattern')">
      Only values between 1 and 120 allowed
    </mat-error>
  </mat-form-field>

  <!-- Temporary holiday date picker -->
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Add temporary holiday</mat-label>

    <input
      matInput
      [matDatepicker]="picker"
      [min]="minTempHolidayDate"
      (dateChange)="addTemporaryHoliday($event.value)"
    >

    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>

    <mat-hint>Only future dates allowed</mat-hint>
  </mat-form-field>

  <!-- Selected temporary holidays -->
  <mat-chip-listbox
    *ngIf="timeConfigForm.value.temporaryholiday?.length">

    <mat-chip
      *ngFor="let d of timeConfigForm.value.temporaryholiday; let i = index"
      removable
      (removed)="removeTemporaryHoliday(i)"
    >
      {{ d | date:'dd MMM yyyy' }}
      <button matChipRemove>
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip>

  </mat-chip-listbox>

  <div class="action-row">
    <button
      mat-raised-button
      color="primary"
      (click)="saveTimeConfiguration()"
      [disabled]="timeConfigForm.invalid || isEndTimeInvalid()"
    >
      Save configuration
    </button>
  </div>

</form>

        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
